import { Scenarios } from '@jfs/network'

const fetchTransactionHistory = {
  default: [
    {
      url: /agenthistory/,
      method: 'POST',
      response: {
        responseList: [
          {
            transaction: {
              id: '10012226548945383000',
              rrn: '501489453840',
              originalId: '10012226548945383000',
              idempotentKey: '3080644889884548',
              arrivalDate: 'Thu Sep 22 13:35:45 IST 2022',
              created: 'Thu Sep 22 13:35:45 IST 2022',
              status: 'FAILED',
              invoice: '3080644889884548',
              responseTime: 'Thu Sep 22 13:35:57 IST 2022',
              method: {
                type: '115',
                subType: '550',
              },
              initiatingEntity: {
                entityId: '8030',
              },
              failureCode: '30542',
              failureReason: 'Invalid Card Number Bin Details',
            },
            amount: {
              netAmount: 50.0,
              grossAmount: 50.0,
            },
            payee: {
              name: 'RRL account',
              bankName: 'JPB',
              bankIfscCode: 'JIOP0000001',
              accountNumber: 'RPHUB03563501500',
              accountType: '0',
              aadhaar: {},
            },
            payer: {
              mobileNumber: '8237178545',
              mobileNumberCountryCode: '91',
              bankId: '100031',
              bankName: '100031',
              accountType: 'null',
              aadhaar: {
                aadhaarNumber: 'XXXXXXXX7026',
              },
            },
          },
          {
            transaction: {
              id: '10012226539258424000',
              rrn: '501392584250',
              originalId: '10012226539258424000',
              idempotentKey: '3537381428160286',
              arrivalDate: 'Thu Sep 22 10:54:18 IST 2022',
              created: 'Thu Sep 22 10:54:18 IST 2022',
              status: 'SUCCESS',
              invoice: '3537381428160286',
              responseTime: 'Thu Sep 22 10:54:22 IST 2022',
              method: {
                type: '424',
                subType: '550',
              },
              initiatingEntity: {
                entityId: '8030',
              },
            },
            amount: {
              netAmount: 10.0,
              grossAmount: 10.0,
            },
            payee: {
              name: 'Sai vinayak Bangera',
              bankId: '607884',
              bankName: 'abc Payments Bank',
              bankIfscCode: 'JIOP0000001',
              accountNumber: '30000001044057',
              accountType: '0',
              aadhaar: {
                aadhaarNumber: 'XXXXXXXX8858',
              },
            },
            payer: {
              name: 'Niraj Rajan',
              mobileNumber: '8237178545',
              mobileNumberCountryCode: '91',
              bankId: '607884',
              bankName: 'EFG Payments Bank',
              bankIfscCode: 'JIOP0000001',
              accountNumber: '30000001054788',
              accountType: 'null',
              aadhaar: {
                aadhaarNumber: 'XXXXXXXX7026',
              },
            },
          },
          {
            transaction: {
              id: '10012226539036055000',
              rrn: '501390360551',
              originalId: '10012226539036055000',
              idempotentKey: '5690433825359260',
              arrivalDate: 'Thu Sep 22 10:50:36 IST 2022',
              created: 'Thu Sep 22 10:50:36 IST 2022',
              status: 'SUCCESS',
              invoice: '5690433825359260',
              responseTime: 'Thu Sep 22 10:50:39 IST 2022',
              method: {
                type: '115',
                subType: '550',
              },
              initiatingEntity: {
                entityId: '8030',
              },
            },
            amount: {
              netAmount: 50.0,
              grossAmount: 50.0,
            },
            payee: {
              name: 'RRL account',
              bankName: 'JPB',
              bankIfscCode: 'JIOP0000001',
              accountNumber: 'RPHUB03563501500',
              accountType: '0',
              aadhaar: {},
            },
            payer: {
              name: 'Niraj Rajan',
              mobileNumber: '8237178545',
              mobileNumberCountryCode: '91',
              bankId: '607884',
              bankName: 'JIO Payments Bank',
              bankIfscCode: 'JIOP0000001',
              accountNumber: '30000001054788',
              accountType: 'null',
              aadhaar: {
                aadhaarNumber: 'XXXXXXXX7026',
              },
            },
          },
          {
            transaction: {
              id: '10012226538978937000',
              rrn: '501389789381',
              originalId: '10012226538978937000',
              idempotentKey: '7098759447595014',
              arrivalDate: 'Thu Sep 22 10:49:39 IST 2022',
              created: 'Thu Sep 22 10:49:39 IST 2022',
              status: 'SUCCESS',
              invoice: '7098759447595014',
              responseTime: 'Thu Sep 22 10:49:42 IST 2022',
              method: {
                type: '217',
                subType: '550',
              },
              initiatingEntity: {
                entityId: '8030',
              },
            },
            amount: {
              netAmount: 100.0,
              grossAmount: 100.0,
            },
            payee: {
              name: 'Niraj Rajan',
              mobileNumber: '8237178545',
              mobileNumberCountryCode: '91',
              bankId: '607884',
              bankName: 'JIO Payments Bank',
              bankIfscCode: 'JIOP0000001',
              accountNumber: '30000001054788',
              accountType: '0',
              aadhaar: {
                aadhaarNumber: 'XXXXXXXX7026',
              },
            },
            payer: {
              name: 'RRL account',
              bankName: 'JPB',
              bankIfscCode: 'JIOP0000001',
              accountNumber: 'RPHUB03563501500',
              accountType: 'null',
              aadhaar: {},
            },
          },
          {
            transaction: {
              id: '10012226538844719000',
              rrn: '501388447191',
              originalId: '10012226538844719000',
              idempotentKey: '1009958786614421',
              arrivalDate: 'Thu Sep 22 10:47:25 IST 2022',
              created: 'Thu Sep 22 10:47:25 IST 2022',
              status: 'FAILED',
              invoice: '1009958786614421',
              responseTime: 'Thu Sep 22 10:47:27 IST 2022',
              method: {
                type: '115',
                subType: '550',
              },
              initiatingEntity: {
                entityId: '8030',
              },
              failureCode: '51',
              failureReason: 'Insufficient Fund',
            },
            amount: {
              netAmount: 53.0,
              grossAmount: 53.0,
            },
            payee: {
              name: 'RRL account',
              bankName: 'JPB',
              bankIfscCode: 'JIOP0000001',
              accountNumber: 'RPHUB03563501500',
              accountType: '0',
              aadhaar: {},
            },
            payer: {
              name: 'Niraj Rajan',
              mobileNumber: '8237178545',
              mobileNumberCountryCode: '91',
              bankId: '607884',
              bankName: 'JIO Payments Bank',
              bankIfscCode: 'JIOP0000001',
              accountNumber: '30000001054788',
              accountType: 'null',
              aadhaar: {
                aadhaarNumber: 'XXXXXXXX7026',
              },
            },
          },
          {
            transaction: {
              id: '10012225638837352000',
              rrn: '601388373521',
              originalId: '10012225638837352000',
              idempotentKey: '8661449935799286',
              arrivalDate: 'Tue Sep 13 10:47:17 IST 2022',
              created: 'Tue Sep 13 10:47:17 IST 2022',
              status: 'FAILED',
              invoice: '8661449935799286',
              responseTime: 'Tue Sep 13 10:47:28 IST 2022',
              method: {
                type: '115',
                subType: '550',
              },
              initiatingEntity: {
                entityId: '8030',
              },
              failureCode: '68',
              failureReason: 'Sorry unable to connect with your bank, Please try after sometime',
            },
            amount: {
              netAmount: 500.0,
              grossAmount: 500.0,
            },
            payee: {
              accountType: '0',
              aadhaar: {},
            },
            payer: {
              mobileNumber: '8369353446',
              mobileNumberCountryCode: '91',
              bankId: '100031',
              bankName: '100031',
              accountType: 'null',
              aadhaar: {
                aadhaarNumber: 'XXXXXXXX7026',
              },
            },
          },
          {
            transaction: {
              id: '10012225638556146000',
              rrn: '601385561461',
              originalId: '10012225638556146000',
              idempotentKey: '0824413122039710',
              arrivalDate: 'Tue Sep 13 10:42:36 IST 2022',
              created: 'Tue Sep 13 10:42:36 IST 2022',
              status: 'FAILED',
              invoice: '0824413122039710',
              responseTime: 'Tue Sep 13 10:42:46 IST 2022',
              method: {
                type: '115',
                subType: '550',
              },
              initiatingEntity: {
                entityId: '8030',
              },
              failureCode: '68',
              failureReason: 'Sorry unable to connect with your bank, Please try after sometime',
            },
            amount: {
              netAmount: 10000.0,
              grossAmount: 10000.0,
            },
            payee: {
              accountType: '0',
              aadhaar: {},
            },
            payer: {
              mobileNumber: '8369353445',
              mobileNumberCountryCode: '91',
              bankId: '100031',
              bankName: '100031',
              accountType: 'null',
              aadhaar: {
                aadhaarNumber: 'XXXXXXXX7026',
              },
            },
          },
          {
            transaction: {
              id: '10012225638410196000',
              rrn: '601384101970',
              originalId: '10012225638410196000',
              idempotentKey: '3807199328537397',
              arrivalDate: 'Tue Sep 13 10:40:10 IST 2022',
              created: 'Tue Sep 13 10:40:10 IST 2022',
              status: 'FAILED',
              invoice: '3807199328537397',
              responseTime: 'Tue Sep 13 10:40:12 IST 2022',
              method: {
                type: '115',
                subType: '550',
              },
              initiatingEntity: {
                entityId: '8030',
              },
              failureCode: '51',
              failureReason: 'Insufficient Fund',
            },
            amount: {
              netAmount: 10.0,
              grossAmount: 10.0,
            },
            payee: {
              name: 'RRL account',
              bankName: 'JPB',
              bankIfscCode: 'JIOP0000001',
              accountNumber: 'RPHUB03563501500',
              accountType: '0',
              aadhaar: {},
            },
            payer: {
              name: 'Niraj Rajan',
              mobileNumber: '8237178545',
              mobileNumberCountryCode: '91',
              bankId: '607884',
              bankName: 'JIO Payments Bank',
              bankIfscCode: 'JIOP0000001',
              accountNumber: '30000001054796',
              accountType: 'null',
              aadhaar: {
                aadhaarNumber: 'XXXXXXXX7026',
              },
            },
          },
          {
            transaction: {
              id: '10012225239635921000',
              rrn: '201396359211',
              originalId: '10012225239635921000',
              idempotentKey: '7976933485239443',
              arrivalDate: 'Fri Sep 09 11:00:36 IST 2022',
              created: 'Fri Sep 09 11:00:36 IST 2022',
              status: 'FAILED',
              invoice: '7976933485239443',
              responseTime: 'Fri Sep 09 11:00:47 IST 2022',
              method: {
                type: '115',
                subType: '550',
              },
              initiatingEntity: {
                entityId: '8030',
              },
              failureCode: '30542',
              failureReason: 'Invalid Card Number Bin Details',
            },
            amount: {
              netAmount: 158.0,
              grossAmount: 158.0,
            },
            payee: {
              name: 'RRL account',
              bankName: 'JPB',
              bankIfscCode: 'JIOP0000001',
              accountNumber: 'RPHUB03563501500',
              accountType: '0',
              aadhaar: {},
            },
            payer: {
              mobileNumber: '8369353445',
              mobileNumberCountryCode: '91',
              bankId: '100031',
              bankName: '100031',
              accountType: 'null',
              aadhaar: {
                aadhaarNumber: 'XXXXXXXX7026',
              },
            },
          },
          {
            transaction: {
              id: '10012225163270264000',
              rrn: '101632702650',
              originalId: '10012225163270264000',
              idempotentKey: '5663014204627925',
              arrivalDate: 'Thu Sep 08 17:34:30 IST 2022',
              created: 'Thu Sep 08 17:34:30 IST 2022',
              status: 'FAILED',
              invoice: '5663014204627925',
              responseTime: 'Thu Sep 08 17:34:41 IST 2022',
              method: {
                type: '115',
                subType: '550',
              },
              initiatingEntity: {
                entityId: '8030',
              },
              failureCode: '30542',
              failureReason: 'Invalid Card Number Bin Details',
            },
            amount: {
              netAmount: 50.0,
              grossAmount: 50.0,
            },
            payee: {
              name: 'RRL account',
              bankName: 'JPB',
              bankIfscCode: 'JIOP0000001',
              accountNumber: 'RPHUB03563501500',
              accountType: '0',
              aadhaar: {},
            },
            payer: {
              mobileNumber: '8369353445',
              mobileNumberCountryCode: '91',
              bankId: '100031',
              bankName: '100031',
              accountType: 'null',
              aadhaar: {
                aadhaarNumber: 'XXXXXXXX7026',
              },
            },
          },
        ],
        error: null,
      },
      delay: 500,
    },
  ],
  failed: [
    {
      url: /history/,
      method: 'POST',
      responseCode: 500,
      response: { error: { code: 416, message: 'Invalid request' } },
      delay: 1000,
    },
  ],
} as Scenarios

export { fetchTransactionHistory }
